module.exports = __webpack_public_path__ + "static/pool-a11277c4946ca3cf925e345450a00d66.gif";